module.exports = __webpack_public_path__ + "1793882494189/images/europe.4d55246.png";